import * as d3 from "d3";
import {colonAnnotation, createTooltip, numberFormat, pieChart, responsivefy} from '../functions'

export default function (chart, divId, vizName, resData) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    // load the data
    // axios.post(url, filterParam).then(res => {
        let data = resData;
        console.log("data is:", data)

        data.forEach(function (d) {
            d.metric1 = +d.metric1;
            return d;
        });
        var width = 600, height = 300;
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId).append('svg')
            .attr('width', width)
            .attr('height', height)
            .call(responsivefy)
            .append('g')
        // .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

        var radius = Math.min(width, height) / 2.5;
        console.log("radius", radius)

        const tooltip = createTooltip(divId);

        var g = svg.append("g").attr("transform", "translate(" + width / 1.5 + "," + height / 2.5 + ")");

        var color = d3.scaleOrdinal().range(pieChart);

        var pie = d3.pie()
            .sort(null)
            .value(function (d) {
                return d.metric1;
            }).sort(null);

        var tots = d3.sum(data, function (d) {
            return d.metric1;
        });

        console.log("tots", tots)

        console.log("datapie", data)

        var path = d3.arc()
            .outerRadius(radius - 5)
            .innerRadius(40);

        var arc = g.selectAll(".arc")
            .data(pie(data))
            .enter().append("g")
            .attr("class", "arc");


        arc.append("path")
            .attr("d", path)
            .attr("fill", function (d) {
                return color(d.data.dim1_name);
            })
            .on("mouseover", function(d) {
                console.log(d3.event, d); // For debugging, log the event and data

                tooltip.onMouseOver(d, this, function(d) {
                // Tooltip content callback
                return d.data.dim1_name + '<br>' +
                    Math.round((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%' + '(' + numberFormat(d.data.metric1) + ' out of ' + numberFormat(tots) + ')'
                });  // Pass the event for positioning
            })
            .on('mousemove', function(event) {
                tooltip.onMouseMove(event);  // Update tooltip position on mouse move
            })
            .on("mouseout", function() {
                // Hide the tooltip on mouse out
                tooltip.onMouseLeave();
            });

        arc.append("svg:text")                                     //add a label to each slice
            .attr("transform", function (d) {                    //set the label's origin to the center of the arc
                //we have to make sure to set these before calling arc.centroid
                d.innerRadius = 0;
                d.outerRadius = 40;
                return "translate(" + path.centroid(d) + ")";        //this gives us a pair of coordinates like [50, 50]
            })
            .attr("text-anchor", "middle")                          //center the text on it's origin
            .text(function (d) {
                return numberFormat(d.data.metric1)
            });

        var label = svg.append('g')
            .append('text')
            .attr("x", 70)
            .attr("y", 40)
            .text(chart.y1AxisDisplayName + colonAnnotation + numberFormat(tots))

        console.log(label)

        var legend = svg.append('g')
            .attr("class", "legend")
            .selectAll("g")
            .data(pie(data), function (d) {
                return d.data.dim1_name;
            })//setting the data as we know there are only two set of data[programmar/tester] as per the nest function you have written
            .enter().append("g")
            .attr("transform", function (d, i) {
                return "translate(0," + i * 20 + ")";
            });

        legend.append("rect")
            .attr('x', 10)
            .attr('y', 60)
            .attr("width", 18)
            .attr("height", 18)
            .style("fill", function (d) {
                return color(d.data.dim1_name);
            });

        legend.append("text")
            .attr("x", 40)
            .attr("y", 70)
            .attr("dy", ".35em")
            .text(function (d) {
                return Math.round((d.endAngle - d.startAngle) / (2 * Math.PI) * 100) + '%' + ' ' + d.data.dim1_name
            });
    // })
}
